angular.module('am4').controller('deactivateOrganizationCtrl', function($scope, availableOrganizations, orgData, orgFacService, subscriptionService, tagService, ngDialog, $state, $translate, errorService) {
    var that = this,
        groupByOrganization = $translate.instant('ORGANIZATIONS');

    that.facilities = orgData.facilities.filter(function(facility) {
        return facility.is_active;
    })
    .map(function(facility) {
        return facility.id;
    });

    that.submit = function(organization) {
        that.deactivating = true;

        return orgFacService.deactivateOrganization(orgData.id, organization.id)
        .then(function() {
            // Force reload the organizations & facilities dictionary
            orgFacService.refreshOrganizationsDictionary();
            orgFacService.refreshFacilitiesDictionary();

            ngDialog.closeAll();
            $state.go('app.am4.organizations');
        })
        .catch(function(e) {
            that.deactivating = false;

            errorService.addError('DEACTIVATE_ORGANIZATION_ERROR', e);
        });
    };

    const availableOrgTargets = angular.copy(availableOrganizations);

    // Cannot move facilities into the organization that you're currently deactivating
    delete availableOrgTargets[orgData.id];

    that.organizations = Object.keys(availableOrgTargets)
    .map(function(id) {
        return {
            id: id,
            label: availableOrgTargets[id],
            group: groupByOrganization
        };
    })
    .sort(function(a, b) {
        if (a.label < b.label) { return -1; }
        if (a.label > b.label) { return 1; }
        return 0;
    });

    that.organizations.unshift({
        label: $translate.instant('DO_NOT_MOVE_DELETE', {
            facilitiesNumber: that.facilities.length
        }),
        id: null,
        group: $translate.instant('OTHER_ACTIONS')
    });

    that.targetOrganization = that.organizations[0];

    that.initVisibleNumberUiSelectChoices = 20;
    that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;

    $scope.$on('uiSelectInfiniteScroll:resetLimit', function() {
        that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;
    });

    that.showMoreUiSelectChoices = function() {
        that.visibleNumberUiSelectChoices += that.initVisibleNumberUiSelectChoices;
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/deactivateOrganizationCtrl.js